import { BOOLEAN } from '@/utils/constants'

/** 公告状态选项 */
export const BE_SHOW_OPTIONS = [
  { value: BOOLEAN.NO, label: '不可见' },
  { value: BOOLEAN.YES, label: '可见' }
]

/** 是否已读：0-未读，1-已读，2-无状态（用户在公告创建之后创建，则用户公告为无状态） */
export enum NOTICE_READ_STATUS {
  /** 未读 */
  NO,
  /** 已读 */
  YES,
  /** 无状态 */
  NONE
}
